import { Injectable } from '@angular/core';

import { Attribute } from '@shared/models/attribute';
import { LopAttributeAssignment } from '@shared/models/lop-attribute-assignment';
import { comparator } from '@shared/utils/comparator';

@Injectable()
export class LopAttributeAssignmentsSortingService {
  /**
   * Sorts the assignments based on the order of lop attributes.
   * Sorting will be made based on the order of provided lop attributes.
   * The sorting is not made based on 'Order' property of lop attribute to avoid the need to
   * change logic here if ordering (asc, desc) of lop attributes changes in the future.
   */
  sort(
    assignments: LopAttributeAssignment[],
    attributes: Attribute[]
  ): LopAttributeAssignment[] {
    return [...assignments].sort(
      (a: LopAttributeAssignment, b: LopAttributeAssignment) => {
        const valueA = this.sortAccessor(a, attributes);
        const valueB = this.sortAccessor(b, attributes);

        return comparator(valueA, valueB);
      }
    );
  }

  /**
   * Sort by order in the lop attributes instead of order property
   */
  private sortAccessor(
    assignment: LopAttributeAssignment,
    attributes: Attribute[]
  ): number {
    return attributes?.findIndex(x => x.id === assignment.attributeId);
  }
}
